/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import HomeIcon from '@domain-group/fe-co-icon/lib/js/home';
import ChevronRightIcon from '@domain-group/fe-co-icon/lib/js/chevron-right';
import Link from 'next/link';
import { NavigationPage } from 'src/lib/docs-api';
import * as styles from './breadcrumbs.styles';

interface BreadcrumbsProps {
  withBreadcrumbs: boolean;
  documentList: NavigationPage[];
  version: string;
  baseUrl: string;
  isFullWidth?: boolean;
}

/* eslint-disable react/prefer-stateless-function */
class Breadcrumbs extends React.PureComponent<BreadcrumbsProps> {
  addActiveBreadcrumbs(
    baseUrl: string,
    documentList: NavigationPage[],
    currentBreadcrumbs: Breadcrumb[],
  ): Breadcrumb[] {
    documentList
      .filter(({ isCurrent, children }) => isCurrent || children.length > 0)
      // eslint-disable-next-line array-callback-return
      .forEach((page) => {
        if (page.isPage) {
          // don't add the 'guides' or 'references' sections
          currentBreadcrumbs.push({
            title: page.title,
            url: `${baseUrl}${page.path}`,
          });
        }

        // eslint-disable-next-line no-param-reassign
        currentBreadcrumbs = this.addActiveBreadcrumbs(
          baseUrl,
          page.children,
          currentBreadcrumbs,
        );
      });
    return currentBreadcrumbs;
  }

  render(): React.ReactNode {
    const { withBreadcrumbs, documentList, version } = this.props;
    let breadcrumbList: Breadcrumb[] = [];

    if (withBreadcrumbs && documentList.length > 0) {
      const baseUrl = `/docs/${version}/`;
      breadcrumbList.push({
        title: 'Documentation',
        url: baseUrl,
      });
      breadcrumbList = this.addActiveBreadcrumbs(
        baseUrl,
        documentList,
        breadcrumbList,
      );
    }

    const breadcrumbs = breadcrumbList
      .filter(Boolean)
      .filter(({ title, url }) => title && url);

    if (breadcrumbs.length === 0) {
      return <noscript />;
    }

    const lastCrumb = breadcrumbs.pop();
    const crumbs = breadcrumbs.map((crumb) => (
      <li css={styles.crumb} key={crumb.title}>
        <Link href={crumb.url} passHref prefetch={false}>
          <a css={styles.link} title={crumb.title}>
            <ChevronRightIcon css={styles.chevron} />
            {crumb.title}
          </a>
        </Link>
      </li>
    ));

    return (
      <div css={styles.wrapper}>
        <ul css={styles.innerWrapper(this.props.isFullWidth)}>
          <li css={styles.crumb} key="Home">
            <Link passHref prefetch={false} href={this.props.baseUrl}>
              <a css={styles.link} title="Home">
                <HomeIcon className="is-small" css={styles.homeIcon} />
              </a>
            </Link>
          </li>
          {crumbs}

          {lastCrumb && (
            <li css={styles.crumb} key={lastCrumb.title}>
              <span css={styles.link}>
                <ChevronRightIcon css={styles.chevron} />
                {lastCrumb.title}
              </span>
            </li>
          )}
        </ul>
      </div>
    );
  }
}

interface Breadcrumb {
  title: string;
  url: string;
}
export default Breadcrumbs;
